/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'ai-mate.chat-error.description': 'Try <btn>reload chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'You have reached the maximum number of requests. Please try again later.',
  'ai-mate.chat-error.rate-limited-title': 'Too many requests',
  'ai-mate.chat-error.title': "We're not sure what went wrong",
  'conversation-assistant-button.label': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Scroll left',
  'horizontal-scroll-container.scroll-right': 'Scroll right',
};
